export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';

const initialState = {
  isMfaUser: null,
  profile: null,
};

const nonMfaProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        isMfaUser: action.payload.isMfaUser,
        profile: action.payload.profile,
      };
    default:
      return state;
  }
};

export default nonMfaProfileReducer;
